import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { format } from 'date-fns';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { AppState } from './app.module';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  settingsLoaded: Observable<boolean>;
  currentYear: string;

  constructor(
    public router: Router,
    private store: Store<AppState>,
    private gtmService: GoogleTagManagerService
  ) {
    console.log(`iQD Budget Calculator ${environment.version}`);

    this.router.events.forEach((item) => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url,
        };

        this.gtmService.pushTag(gtmTag);
      }
    });

    this.currentYear = format(new Date(), 'yyyy');
    this.store.dispatch({ type: 'LOAD_SETTINGS' });
    this.settingsLoaded = this.store.select((state) => state.settings.loaded);
  }
}
